export default Object.freeze({
  SqlServer: 0,
  MySql: 2,
});
